import ready from "document-ready";
require("slick-carousel-latest");

ready((event) => {

    const itemArchive = document.querySelectorAll(".dropdown_item");
    const burger = document.querySelector('.burger');
    const mobilFormButton = document.querySelector('.mobile-form-button');
    const alertBLock = document.querySelector('.alert');
    const alertButton = document.querySelector('.alert .close');
    const showMoreButtons = document.querySelectorAll('.show-more-block .show-more-button');
    const simpleShowMoreButtons = document.querySelectorAll('.simple-show-more-block .show-more-button');
    const fancyBoxes = document.querySelectorAll('.fancy-block');
    const body = document.body;
    const header = document.getElementById("page-header");
    const modal = document.getElementById('staticBackdrop');
    const modalClose = document.querySelector('.modal .btn-close');
    const customDropdownItem = document.querySelectorAll('.custom-dropdown-item');
    const customDropdownQuestion = document.querySelector('.dropdown-question');
    const phoneNumber = document.querySelectorAll('.upper-menu-left > a, .footer-tel a, .tel_button');
    const blogCategory = document.getElementsByClassName("blog-category");
    const blogItems = document.querySelectorAll(".blog-category");
    const filtersBlock = document.getElementsByClassName("filters-block");
    const filterCheckbox = document.querySelectorAll(".filters-block-checkbox");
    const paginationBlock = document.querySelector('.hotels-navigation');

    if (phoneNumber) {
        phoneNumber.forEach((anchor) => {
            anchor.addEventListener('click', (event) => {
                fbq('trackCustom', 'phone number', {
                    value: 'clicked',
                });
            });
        });
    }

    // if($('body').hasClass('rtl')){
    //
    //
    //     let intervalValue = '';
    //
    //     intervalValue = setInterval(function () {
    //         if ($('.iti-flag').length > 0) {
    //             $('.iti-flag').addClass('il');
    //             $('.country-list .country').removeClass('active highlight');
    //             clearInterval(intervalValue);
    //         }
    //     }, 1000);
    //
    //
    // }


    // script for the menu TABS
    let windowsize = $(window).width();
    $(window).resize(function () {
        windowsize = $(window).width();
    });

    $('.tablinks').on('mouseenter', function (event) {
        // if(windowsize > 991){
        let i, tabcontent, tablinks;
        let tabName = $(this).attr("data-category");

        tabcontent = $(this).closest('.dropdown-tabs').find(".tabcontent");

        for (i = 0; i < tabcontent.length; i++) {
            tabcontent[i].classList.remove("d-flex");
        }
        tablinks = $(this).closest('.dropdown-tabs').find(".tablinks");
        for (i = 0; i < tablinks.length; i++) {
            tablinks[i].className = tablinks[i].className.replace(" active", "");
        }
        document.getElementById(tabName).classList.add("d-flex");
        event.currentTarget.className += " active";
        // }
    });

    //inner hotel tabs
    $('.hotel-activities-bar a').on('click', function (event) {
        let tabName = $(this).attr("data-tab");
        $('.hotel-activities-bar a').removeClass('active');
        $(this).addClass('active');

        $('.hotel-activities-list ul').removeClass('d-block');
        $('#' + tabName).addClass('d-block');

    });

    //adding country name into hidden field in contact form
    // $('.hero-container .wpcf7-phonetext').on('change', function () {
    //     let currentCountry = $('.hero-container .selected-flag').attr('title');
    //     $('.hero-container .hidden-country').val(currentCountry.split(':')[0]);
    // });
    // $('.mobile-form .wpcf7-phonetext').on('change', function () {
    //     let currentCountry = $('.mobile-form .selected-flag').attr('title');
    //     $('.mobile-form .hidden-country').val(currentCountry.split(':')[0]);
    // });


    // cookies for modal
    function getCookie(name) {
        let matches = document.cookie.match(new RegExp(
            "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
        ));
        return matches ? decodeURIComponent(matches[1]) : undefined;
    }

    if (header) {
        /**  sticky header **/
        if (pageYOffset > 0) {
            header.classList.add("sticky-header");
        }
        window.addEventListener("scroll", function () {
            if (pageYOffset > 0) {
                header.classList.add("sticky-header");
            } else if (pageYOffset === 0) {
                header.classList.remove("sticky-header");
            }
        });
    }

    if (customDropdownItem) {
        customDropdownItem.forEach((anchor) => {
            anchor.addEventListener("click", function (event) {
                this.classList.toggle('opened');
            });
        });
    }

    // bootstrap modal for Show more items
    if (showMoreButtons.length) {
        showMoreButtons.forEach((anchor) => {
            anchor.addEventListener("click", function (event) {
                let parentItem = $(this).closest('.show-more-block');
                let showMoreTitle = parentItem.find('h3').html();
                let showMoreContent = parentItem.find('.popup-text').html();
                $('.modal-title').html(showMoreTitle);
                $('.modal-body').html(showMoreContent);
                $('#showMoreBlock').modal();
            });
        });
    }


    // partners modal
    $('.hero-partner-button').on('click', function(){
        $('#formBlock').modal();
    });

    // simple show more block
    if (simpleShowMoreButtons.length) {
        $('.inner-hotels, .inner-things, .sights, .partners-items').on('click', '.simple-show-more-block .show-more-button', function () {
            let parentItem = $(this).closest('.simple-show-more-block');
            parentItem.find('.inner-description').toggleClass('hidden-description');
            $(this).toggleClass('opened');
        });
    }


    // scroll to buttons
    $(".scroll-to a").on('click', function () {
        let sectionId = $(this).attr('rel');
        let item = $("#" + sectionId);
        if (item.length > 0) {
            $('html, body').animate({
                scrollTop: item.offset().top - 200
            }, 1500);
        }

    });

    // fancy box images
    if (fancyBoxes.length) {
        let i = 0;
        $(fancyBoxes).each(function () {
            $(this).find('.wp-block-image').each(function () {
                let link = $(this).find('a').attr('href');
                $(this).find('a').attr('data-src', link);
                $(this).find('a').attr('data-fancybox', 'fancy' + i);
            });
            i++;
        });
    }


    if (alertButton) {
        let alertCookie = getCookie('alert-banner');
        alertButton.addEventListener("click", function (event) {
            alertBLock.classList.add('d-none');
            body.classList.remove('alert-banner');
            if (!alertCookie) {
                document.cookie = "alert-banner=true; path=/;";
            }
        });
        if (!alertCookie) {
            body.classList.add('alert-banner');
            alertBLock.classList.add('showed');
        }
    }

    if (burger) {
        burger.addEventListener("click", function (event) {
            body.classList.toggle("mobile_opened");
            if (body.classList.contains('mobile_form_opened')) {
                body.classList.remove('mobile_form_opened');
            }
        });
    }

    if (mobilFormButton) {
        mobilFormButton.addEventListener("click", function (event) {
            body.classList.toggle("mobile_form_opened");
            if (body.classList.contains('mobile_opened')) {
                body.classList.remove('mobile_opened');
            }
        });
    }

    if (itemArchive.length) {
        itemArchive.forEach((anchor) => {
            anchor.addEventListener("click", function (event) {
                event.stopPropagation();
                if (this.classList.contains('open') && event.target.tagName !== 'INPUT' && event.target.tagName !== 'LI' && event.target.tagName !== 'UL'
                    && event.target.tagName !== 'DIV') {
                    this.classList.remove('open');
                } else {
                    [].forEach.call(itemArchive, function (el) {
                        el.classList.remove("open");
                    });
                    this.classList.add('open');
                }
            });
        });

        document.documentElement.addEventListener("click", function (event) {
            if (event.target.classList.contains('dropdown_item') === false) {
                [].forEach.call(itemArchive, function (el) {
                    el.classList.remove("open");
                });
            }
        })
    }

    const catItem = document.querySelectorAll('.cat-tab-item, .schema-faq-section, .amentie-item, .rank-math-list-item');

    if (catItem) {
        catItem.forEach((anchor) => {
            anchor.addEventListener("click", function (event) {
                anchor.classList.toggle("opened");
            });
        });
    }

    const seoBlock = $('.schema-faq-section');
    if (seoBlock) {
        $('.schema-faq-question').each(function () {
            $(this).replaceWith($('<h3 class="schema-faq-question mb-0">' + this.innerHTML + '</h3>'));
        });
    }


    if ($('input[name="daterange"]').length > 0) {

        $(function () {
            $('input[name="daterange"]').daterangepicker();
        });

        $('input[name="daterange"]').on('apply.daterangepicker', function (ev, picker) {
            $('#date-start').value = picker.startDate.format('YYYY-MM-DD');
            $('input[name="date-end"]').value = picker.endDate.format('YYYY-MM-DD');
        });

    }


    // let modalCookie = getCookie('modal');
    //
    // if(modalClose){
    //     modalClose.addEventListener("click", function (event) {
    //         modal.classList.remove('active');
    //     });
    // }
    //
    // if(!modalCookie){
    //
    //     setTimeout(function(){
    //         modal.classList.add('active');
    //     }, 5000);
    //
    //     setTimeout(function(){
    //         if(modal.classList.contains('active')) {
    //             modal.classList.remove('active');
    //         }
    //     }, 12000);
    //
    //
    //
    //     let date = new Date(Date.now() + (3600 * 1000) );
    //     date = date.toUTCString();
    //     document.cookie = "modal=true; path=/; expires=" + date;
    // }

    const advantages = document.querySelectorAll(".advantages-carousel");

    if (advantages.length > 0) {
        $(".advantages-carousel > .wp-block-group__inner-container").slick({
            infinite: true,
            slidesToShow: 4,
            arrows: false,
            cssEase: "linear",
            draggable: "false",
            pauseOnFocus: "false",
            autoplay: false,
            autoplaySpeed: 3000,
            // speed: 4000,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                        dots: true,
                    },
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                        dots: true,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        dots: true,
                    },
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        dots: true,
                    },
                },
            ],
        });
        $(".advantages-carousel").css("opacity", 1);
        // import(/* webpackPrefetch: true */ "slick-carousel-latest").then(
        //     (module) => {
        //         (($) => {
        //
        //
        //         })(jQuery);
        //     }
        // );
    }


    const recommendedDestinations = $('.recommended-destinations .inner-hotels');

    if (recommendedDestinations.length > 0) {
        recommendedDestinations.slick({
            infinite: true,
            slidesToShow: 5,
            arrows: true,
            cssEase: "linear",
            draggable: "false",
            pauseOnFocus: "false",
            autoplay: true,
            dots: false,
            autoplaySpeed: 2000,
            // speed: 4000,
            slidesToScroll: 5,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                    },
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    },
                },
            ],
        });
    }


    const gallerySlider = document.querySelectorAll(".gallery-slider");

    if (gallerySlider.length > 0) {
        $(".gallery-slider-for > .blocks-gallery-grid").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            asNavFor: '.gallery-slider-nav > .blocks-gallery-grid',
        });
        $('.gallery-slider-nav > .blocks-gallery-grid').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            asNavFor: '.gallery-slider-for > .blocks-gallery-grid',
            arrows: true,
            dots: true,
            // centerMode: true,
            focusOnSelect: true,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        arrows: false,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                        dots: false
                    },
                },
            ]
        });
        $('.gallery-slider').css('opacity', 1);

    }

    // inner hotel gallery
    const innerHotelGallery = $(".single-innerhotels .gallery-section");

    if (innerHotelGallery.length > 0) {
        if($(".single-innerhotels .gallery-section .gallery-item").length > 3){
            innerHotelGallery.slick({
                infinite: true,
                slidesToShow: 3,
                arrows: true,
                cssEase: "linear",
                draggable: "false",
                pauseOnFocus: "false",
                autoplay: false,
                dots: false,
                // autoplaySpeed: 2000,
                // speed: 4000,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                        },
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        },
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        },
                    },
                ],
            });
        }

        $('.single-innerhotels .gallery-section').css('opacity', 1);

    }



    // Add smooth scrolling to all links
    $("a").on('click', function (event) {
        if (this.hash) {
            // Prevent default anchor click behavior
            event.preventDefault();

            // Store hash
            let hash = this.hash;
            let commonHeight = 150;
            // Using jQuery's animate() method to add smooth page scroll
            // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
            if (document.body.classList.contains('single-innerhotels')) {
                commonHeight = 200;
            }

            $('html, body').animate({
                    scrollTop: $(hash).offset().top - commonHeight
                },
                1000
            );
        }

    });


    /** Ajax category posts for blog **/

    if (blogCategory) {
        const blogWrap = document.getElementById("info-block-posts");
        for (let categoryItems of blogCategory) {
            categoryItems.addEventListener("click", function (e) {
                [].forEach.call(blogItems, function (el) {
                    el.classList.remove("active");
                });
                this.classList.add("active");
                const data = {
                    'action': 'info_categories',
                    'term': this.dataset.slug
                };

                $.ajax({
                    url: ajaxPersonal.url,
                    data: data,
                    type: "POST",
                    success: function (response) {
                        if (response && blogWrap) {
                            blogWrap.innerHTML = response;
                        }
                    }
                });
            });
        }
    }


    /**  Ajax for the filter block **/
    let blocker = 0;
    let startFilterTerms = {};

    // $.urlParam = function(name){
    //     let results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    //     if (results==null) {
    //         return null;
    //     }
    //     return decodeURI(results[1]) || 0;
    // }

    // console.log($.urlParam('Star'), 'star');
    // if($.urlParam('Star')){
    //     [].forEach.call(filterCheckbox, function (item) {
    //         if(item.getAttribute("slug") == $.urlParam('Star')){
    //             item.checked = true;
    //         }
    //     });
    // }


    let paged = 1;
    function submitHotelFilters(more, lazy) {

        let selectedCategories = [];
        let catInput = "";
        let excluded_posts = $('.excluded-posts').html().replace(/\s+/g, '');

        const innerHotelsWrap = document.querySelector('.inner-hotels');
        const innerHotelCategory = document.querySelector('.filters-block-wrap').dataset.hotelCategory;
        const filterHotel = document.querySelector('.filters-block-wrap').dataset.filter;

        let showMore = more;

        paged++;
        if (filterCheckbox.length > 0) {

            // $(".filters-block-checkbox").each(function( index ) {

            let checked = 0;
            [].forEach.call(filterCheckbox, function (item) {
                if (item.checked) {
                    selectedCategories.push([item.value, item.getAttribute("parent")]);
                    if(!checked){
                        checked = 1;
                    }
                }
            });

            if(!checked){
                $('.filter-group').removeClass('main-group');
            }


            // if ($(this).is(':checked')) {
            //     selectedCategories.push([$(this).val(), $(this).attr("parent")]);
            // }
            // });
        }


        const data = {
            'action': 'filter_hotels',
            'term': selectedCategories,
            'innerHotelCategory': innerHotelCategory,
            'paged': paged,
            'more' : showMore,
            'excluded' : excluded_posts,
            'filter': filterHotel,
        };

        // console.log(selectedCategories);

        if (!blocker) {
            $('.filter-group .form-item').each(function (i) {
                let formItemId = $(this).find('label').attr('for');
                startFilterTerms[formItemId] = $(this).find('.filter-count').html();
            });
            blocker = 1;
        }

        if(canBeLoaded){
            $.ajax({
                url: ajaxPersonal.url,
                data: data,
                dataType: 'JSON',
                beforeSend: function( xhr ){
                    // you see, the AJAX call is in process, we shouldn't run it again until complete
                    $('.spinner-border').addClass('d-flex');
                    canBeLoaded = false;

                },
                success: function (response) {
                    let filterTerms = {};

                    $('.spinner-border').removeClass('d-flex');
                    canBeLoaded = true;

                    if (response.filterArray) {
                        $.each(response.filterArray, function (index, value) {

                            if (index !== 'Location Rating' && index !== 'Guest Rating') {
                                value.forEach(function (item, i, arr) {
                                    filterTerms[item[3]] = item[1];
                                });
                            } else {
                                $.each(value, function (key, innerValue) {
                                    filterTerms[key + index] = innerValue.length;
                                });
                            }
                        });

                        $('.filter-group .form-item').each(function (i) {
                            if (!$(this).parent().hasClass('main-group')) {
                                if (!Object.keys(filterTerms).includes($(this).find('label').attr('for'))) {
                                    $(this).find('label').addClass('disabled');
                                    $(this).find('.filter-count').html("0");
                                } else {
                                    $(this).find('label').removeClass('disabled');
                                    $(this).find('.filter-count').html(filterTerms[$(this).find('label').attr('for')]);
                                }
                            }

                        });
                    } else {
                        $('.filter-group').removeClass('main-group');
                        $('.filter-group .form-item').each(function (i) {
                            $(this).find('.filter-count').html(startFilterTerms[$(this).find('label').attr('for')]);
                            $(this).find('label').removeClass('disabled');
                        });
                    }

                    // console.log(startFilterTerms, 'startFilterTerms');
                    if (response && innerHotelsWrap) {

                        if(showMore){
                            $('.inner-hotels-wrap').append(response.data);

                            $('.excluded-posts').append(response.exclude_value);

                            if($('.excluded-posts').html().split(',').length == $('.excluded-posts').attr('data-total')){
                                $('#more_posts').removeClass('d-flex').addClass('d-none');
                            } else {
                                $('#more_posts').addClass('d-flex').removeClass('d-none');
                            }
                        } else {
                            $('.excluded-posts').html(response.exclude_value);
                            $('.excluded-posts').attr('data-total', response.total_count);

                            if($('.excluded-posts').html().split(',').length == $('.excluded-posts').attr('data-total')){
                                $('#more_posts').removeClass('d-flex').addClass('d-none');
                            } else {
                                $('#more_posts').addClass('d-flex').removeClass('d-none');
                            }
                            $('.inner-hotels-wrap').html(response.data);
                        }


                    } else {
                        console.log('error');
                    }
                }
            });
        }

    }

    // partners ajax
    $('.page-template-page-partners .magazine-category span').on('click', function () {

        $('.magazine-category').removeClass('active');
        $(this).parent().addClass('active');
        let partnerCat = $(this).attr("data-tag");

        submitPartners('', partnerCat);

    });

    $('.page-template-page-partners .magazine-block-categories-mobile .dropbtn').on('change', function () {
        let partnerCat = $(this).val();
        submitPartners('', partnerCat);
    });


    function submitPartners(more, cat){
        let partnersWrap = $('.partners-items');

        const data = {
            'action': 'partners_posts',
            'partnersId': cat,
        };


        $.ajax({
            url: ajaxPersonal.url,
            data: data,
            dataType: 'JSON',
            success: function (response) {

                if(response && partnersWrap.length > 0){
                    partnersWrap.html(response.data);
                }

            }
        });


    }





    // magazine ajax
    $('.tax-magazine-category .magazine-category span').on('click', function () {

        $('.magazine-category').removeClass('active');
        $(this).parent().addClass('active');
        let magazineCat = $(this).attr("data-tag");

        submitMagazine('', magazineCat);

    });

    $('.tax-magazine-category .magazine-block-categories-mobile .dropbtn').on('change', function () {
        let magazineCat = $(this).val();
        submitMagazine('', magazineCat);
    });


    function submitMagazine(more, cat){
        const magazineRegion = $('.magazine-items').attr('data-region');
        let magazineTag = $('.excluded-posts').attr('data-tag');
        let showMore = more;
        let magazineWrap = $('.info-block-posts-wrap');
        let excluded_posts = $('.excluded-posts').html().replace(/\s+/g, '');

        if(cat){
            magazineTag = cat;
            $('.excluded-posts').attr('data-tag', cat);
        }


        const data = {
            'action': 'magazine_posts',
            'magazineRegion': magazineRegion,
            'more' : showMore,
            'magazineTag': magazineTag,
            'excluded' : excluded_posts,
        };


        $.ajax({
            url: ajaxPersonal.url,
            data: data,
            dataType: 'JSON',
            beforeSend: function( xhr ){
                // you see, the AJAX call is in process, we shouldn't run it again until complete
                if(showMore){
                    $('.spinner-border').addClass('d-flex');
                }


            },
            success: function (response) {
                if(showMore){
                    $('.spinner-border').removeClass('d-flex');
                }
                if(response && magazineWrap.length > 0){

                    if(showMore){
                        magazineWrap.append(response.data);

                        $('.excluded-posts').append(response.exclude_value);

                        if($('.excluded-posts').html().split(',').length == $('.excluded-posts').attr('data-total')){
                            $('#more_posts').removeClass('d-flex').addClass('d-none');
                        } else {
                            $('#more_posts').addClass('d-flex').removeClass('d-none');
                        }
                    } else {
                        $('.excluded-posts').html(response.exclude_value);
                        $('.excluded-posts').attr('data-total', response.total_count);

                        if($('.excluded-posts').html().split(',').length == $('.excluded-posts').attr('data-total')){
                            $('#more_posts').removeClass('d-flex').addClass('d-none');
                        } else {
                            $('#more_posts').addClass('d-flex').removeClass('d-none');
                        }
                        magazineWrap.html(response.data);
                    }


                }

            }
        });


    }


    function submitThingsFilters(more, attractiontCat) {
        let selectedCategories = [];
        let catInput = "";
        let attractiontTag = attractiontCat;

        const innerThingsWrap = document.querySelector('.inner-things');
        const innerThingsCategory = document.querySelector('.filters-block-wrap').dataset.thingCategory;
        let excluded_posts = $('.excluded-posts').html().replace(/\s+/g, '');
        let paged = 1;
        let showMore = more;

        if (paginationBlock) {
            paged = paginationBlock.dataset.paged;
        }

        if (filterCheckbox.length > 0) {
            let checked = 0;
            [].forEach.call(filterCheckbox, function (item) {
                if (item.checked) {
                    selectedCategories.push([item.value, item.getAttribute("parent")]);
                    if(!checked){
                        checked = 1;
                    }
                }
            });

            if(!checked){
                $('.filter-group').removeClass('main-group');
            }
        }


        const data = {
            // 'action': 'filter_sight',
            'action': 'filter_things',
            'term': selectedCategories,
            'attractionTag': attractiontTag,
            'innerThingCategory': innerThingsCategory,
            // 'more' : showMore,

            // 'excluded' : excluded_posts,
        };

        if (!blocker) {
            startFilterTerms = {};
            $('.filter-group .form-item').each(function (i) {
                let formItemId = $(this).find('label').attr('for');
                let formItemCount = $(this).find('.filter-count').html();
                startFilterTerms[formItemId] = formItemCount;
            });
            blocker = 1;
        }

        $.ajax({
            url: ajaxPersonal.url,
            data: data,
            dataType: 'JSON',
            success: function (response) {

                let filterTerms = {};

                if (response.filterArray) {

                    $.each(response.filterArray, function (index, value) {
                        value.forEach(function (item, i, arr) {
                            filterTerms[item[3]] = item[1];
                        });
                    });

                    $('.filter-group .form-item').each(function (i) {
                        if (!$(this).parent().hasClass('main-group')) {
                            if (!Object.keys(filterTerms).includes($(this).find('label').attr('for'))) {
                                $(this).find('label').addClass('disabled');
                                $(this).find('.filter-count').html("0");
                            } else {
                                $(this).find('label').removeClass('disabled');
                                $(this).find('.filter-count').html(filterTerms[$(this).find('label').attr('for')]);
                            }
                        }
                    });
                } else {
                    $('.filter-group').removeClass('main-group');
                    $('.filter-group .form-item').each(function (i) {
                        $(this).find('.filter-count').html(startFilterTerms[$(this).find('label').attr('for')]);
                        $(this).find('label').removeClass('disabled');
                    });
                }

                if (response && innerThingsWrap) {
                    $('.excluded-posts').html(response.exclude_value);
                    $('.inner-things-wrap').html(response.data);
                } else {
                    console.log('error');
                }
            }
        });
    }

    $('.attraction .attraction-tag').on('click', function () {

        $('.attraction .attraction-tag').removeClass('active');
        $(this).addClass('active');
        let attractiontCat = $(this).attr("data-tag");

        startFilterTerms = {};
        $('.filter-group .form-item').each(function (i) {
            let formItemId = $(this).find('label').attr('for');
            startFilterTerms[formItemId] = $(this).find('.filter-count').html();
        });
        blocker = 1;

        [].forEach.call(filterCheckbox, function (item) {
            item.checked = false;
        });
        $('.filter-group').removeClass('main-group');
        submitThingsFilters('', attractiontCat);

    });

    // sight tags ajax
    $('.sight-tags .attraction-tag').on('click', function () {
        $('.sight-tags .attraction-tag').removeClass('active');
        $(this).addClass('active');
        let sightCat = $(this).attr("data-tag");
        let innerRegion = $('.sight-tags').attr("data-thing-category");
        const data = {
            'action': 'filter_sight',
            'sightCat': sightCat,
            'innerRegion': innerRegion
        };

        $.ajax({
            url: ajaxPersonal.url,
            data: data,
            dataType: 'JSON',
            success: function (response) {
                if (response) {
                    $('.sights').html(response.data);
                } else {
                    console.log('error');
                }
            }
        });
    });


    let canBeLoaded = true, // this param allows to initiate the AJAX call only if necessary
        bottomOffset = 2000; // the distance (in px) from the page bottom when you want to load more posts

    // $(window).on('scroll', function(){
    //     if ($('body').hasClass('single-hotels')) {
    //         if( $(document).scrollTop() > ( $(document).height() - bottomOffset ) && canBeLoaded == true ) {
    //             if($('.excluded-posts').html().split(',').length < 10 && $('.excluded-posts').html().split(',').length != $('.excluded-posts').attr('data-total')){
    //
    //                 console.log($('.excluded-posts').html().split(',').length);
    //                 if($('.excluded-posts').html().split(',').length < 30 && $('.excluded-posts').html().split(',').length != $('.excluded-posts').attr('data-total')){
    //
    //                     submitHotelFilters('more', 'lazyLoad');
    //                 }
    //             }
    //         }
    //     }
    // });

    $('#more_posts').on('click', function(){
        if ($('body').hasClass('single-hotels')) {
            submitHotelFilters('more');
        }

        if ($('body').hasClass('tax-magazine-category')) {
            submitMagazine('more');
        }
    });

    // filters block
    if (filtersBlock) {
        filterCheckbox.forEach((anchor) => {
            anchor.addEventListener("click", function (e) {
                if (!$('.filter-group').hasClass('main-group')) {
                    $(this).closest('.filter-group').addClass('main-group');
                }

                let attractiontCat = '';
                if($('.attraction').length > 0){
                    attractiontCat = $('.attraction').find('.active').attr("data-tag");
                }


                if ($('body').hasClass('single-hotels')) {
                    submitHotelFilters();
                } else {
                    submitThingsFilters('', attractiontCat);
                }
            });
        });
    }

    $('.filters-block').on('click', function () {
        $(this).toggleClass('opened');
    });

    // fixed form

    // if($('body').hasClass('fixed-form-option')){
    //
    //     $('.vertical-label').on('click', function(){
    //         $('.hero-container .wpcf7').removeClass('closed');
    //         $('.vertical-label').css('opacity', '0');
    //     });
    //
    //     $('.hero-container .close-button').on('click', function(){
    //         $('.hero-container .wpcf7').addClass('closed');
    //         setTimeout(function(){
    //             $('.vertical-label').css('opacity', '1');
    //         }, 1000);
    //     });
    // }

    // let wpcf7Elm = document.querySelector( '.hero-container .wpcf7' );
    // let wpcf7Elmobile = document.querySelector( '.mobile-form .wpcf7' );
    // let wpcf7Elcareer = document.querySelector( '.careers-form .wpcf7' );

    // if(wpcf7Elcareer){
    //     wpcf7Elcareer.addEventListener( 'wpcf7mailsent', function( event ) {
    //         setTimeout(function(){
    //             $('.careers-form .wpcf7-form').removeClass('sent');
    //         }, 5000);
    //
    //     });
    // }

    let formBlocker = 0;
    let intervalValue = '';


    // if(wpcf7Elmobile){
    //     wpcf7Elmobile.addEventListener( 'wpcf7mailsent', function( event ) {
    //         setTimeout(function(){
    //             $('.mobile-form .wpcf7-form').removeClass('sent');
    //         }, 5000);
    //
    //         let name = $( ".mobile-form input[name=your-name]" ).val();
    //         let phone = $( ".mobile-form input[name=tel-317]" ).val();
    //         let email = $( ".mobile-form input[name=your-email]" ).val();
    //         let people = $( ".mobile-form input[name=number-911]" ).val();
    //         let message = $( ".mobile-form textarea[name=textarea-634]" ).val();
    //
    //         fbq('trackCustom', 'PLAN YOUR HOLIDAY form', {
    //             value: `Name: ${name}, Phone: ${phone}, Email: ${email}, Number of people: ${people}, Message: ${message}`,
    //         });
    //
    //         ga('send', {
    //             hitType: 'event',
    //             eventCategory: 'Form Submit',
    //             eventAction: 'Click',
    //             eventLabel: 'Get Expert Advice',
    //         });
    //     }, false );
    // }

    let stickyForm = $('.sticky-hero-form');
    let buttonClicked = false;

    $(window).on('scroll', function () {
        if ($(window).scrollTop() > 800) {
            if (stickyForm.length > 0) {
                stickyForm.addClass('fixed-hero-form');
                if (!buttonClicked && $(window).width() >= 576) {
                    $('.close-form-btn').click();
                    buttonClicked = true;
                }
            }
        } else {
            stickyForm.addClass('closed');
            stickyForm.removeClass('fixed-hero-form');
            if (buttonClicked && $(window).width() >= 576) {
                $('.close-form-btn').click();
                buttonClicked = false;
            }
        }
    });

    if (stickyForm.length > 0) {
        $('.close-form-btn').on('click', function (el) {
            stickyForm.toggleClass('closed');
        });
    }

    // flights page
    $('.request span').on('click', function(){
        stickyForm.addClass('fixed-hero-form');
        stickyForm.removeClass('closed');
    });

    // google map
    let mapBlock = $('#map');
    if (mapBlock.length > 0) {
        let geocoder;
        let map;
        let address = $('.hotel-map-block').attr("data-map");
        geocoder = new google.maps.Geocoder();
        geocoder.geocode({'address': address}, function (results, status) {
            if (status == 'OK') {
                let mapOptions = {
                    zoom: 18,
                    center: results[0].geometry.location
                }
                map = new google.maps.Map(document.getElementById('map'), mapOptions);
                map.setCenter(results[0].geometry.location);
                var marker = new google.maps.Marker({
                    map: map,
                    position: results[0].geometry.location
                });
            } else {
                console.log('Geocode was not successful for the following reason: ' + status);
            }
        });
        mapBlock.removeClass('opacity-0');
    }


    $('#magazine-categories').on('change', function () {
        window.location.href = $(this).find(":selected").attr('data-link');
    });


    // get the link for the weather destination and month

    $('#weather-destination').on('change', function () {

        let destination = $(this).find(":selected").val();
        let month = $('#weather-month').find(":selected").val()
        let weatherLink = $('.weather-inner-link');
        let spinner = $('.spinner-border');

        if(month.length > 0 && destination.length > 0){
            const data = {
                'action': 'weather_link',
                'month': month,
                'destination': destination
            };
            $.ajax({
                url: ajaxPersonal.url,
                data: data,
                dataType: 'JSON',
                beforeSend: function( xhr ){
                    weatherLink.addClass('isDisabled');
                    spinner.addClass('d-flex');
                },
                success: function (response) {
                    if (response) {
                        $('.weather-inner-link').attr('href', response.data);
                        weatherLink.removeClass('isDisabled');
                        spinner.removeClass('d-flex');
                    } else {
                        weatherLink.removeClass('isDisabled');
                        spinner.removeClass('d-flex');
                        console.log('error');
                    }
                }
            });
        }

    });

    $('#weather-month').on('change', function () {

        let month = $(this).find(":selected").val();
        let destination = $('#weather-destination').find(":selected").val();
        let weatherLink = $('.weather-inner-link');
        let spinner = $('.spinner-border');

        if(month.length > 0 && destination.length > 0){
            const data = {
                'action': 'weather_link',
                'month': month,
                'destination': destination
            };
            $.ajax({
                url: ajaxPersonal.url,
                data: data,
                dataType: 'JSON',
                beforeSend: function( xhr ){
                    weatherLink.addClass('isDisabled');
                    spinner.addClass('d-flex');
                },
                success: function (response) {
                    if (response) {
                        $('.weather-inner-link').attr('href', response.data);
                        weatherLink.removeClass('isDisabled');
                        spinner.removeClass('d-flex');
                    } else {
                        weatherLink.removeClass('isDisabled');
                        spinner.removeClass('d-flex');
                        console.log('error');
                    }
                }
            });
        }

    });


    // get link for the chosen flight destinations
    $('#flight-from-destination').on('change', function () {

        let destinationFrom = $(this).find(":selected").val();

        // if($('#flight-to-destination').find('.disabled').length > 0){
        //     $('#flight-to-destination').find('.disabled').removeClass('disabled');
        // }
        // $(`#flight-to-destination option[value="${destinationFrom}"]`).addClass('disabled');


        let destinationTo = $('#flight-to-destination').find(":selected").val();
        let weatherLink = $('.weather-inner-link');
        let spinner = $('.spinner-border');

        // if(destinationTo.length > 0 && destinationFrom.length > 0){
            const data = {
                'action': 'flight_link',
                'destinationFrom': destinationFrom,
                'destinationTo': destinationTo
            };
            $.ajax({
                url: ajaxPersonal.url,
                data: data,
                dataType: 'JSON',
                beforeSend: function( xhr ){
                    weatherLink.addClass('isDisabled');
                    spinner.addClass('d-flex');
                },
                success: function (response) {
                    if (response) {
                        $('.weather-inner-link').attr('href', response.data);
                        $('#flight-to-destination').addClass('checking-select');


                        $('#flight-to-destination').html(response.desinationToHtml);



                        // let current_desinations_to = response.desinationTo;
                        //
                        //
                        // $('.checking-select option').removeClass('existed');
                        // $('.checking-select option[value="none"]').prop('selected', true);
                        //
                        // jQuery.each( current_desinations_to, function( i, val ) {
                        //     $(`#flight-to-destination option[value="${val}"]`).addClass('existed');
                        // });
                        //
                        // weatherLink.removeClass('isDisabled');





                        spinner.removeClass('d-flex');
                    } else {
                        weatherLink.removeClass('isDisabled');
                        spinner.removeClass('d-flex');
                        console.log('error');
                    }
                }
            });
        // }

    });

    $('#flight-to-destination').on('change', function () {

        let destinationTo = $(this).find(":selected").val();
        let destinationFrom = $('#flight-from-destination').find(":selected").val();
        let weatherLink = $('.weather-inner-link');
        let spinner = $('.spinner-border');


        // if($('#flight-from-destination').find('.disabled').length > 0){
        //     $('#flight-from-destination').find('.disabled').removeClass('disabled');
        // }
        // $(`#flight-from-destination option[value="${destinationTo}"]`).addClass('disabled');

        if(destinationTo.length > 0 && destinationFrom.length > 0){
            const data = {
                'action': 'flight_link',
                'destinationFrom': destinationFrom,
                'destinationTo': destinationTo
            };
            $.ajax({
                url: ajaxPersonal.url,
                data: data,
                dataType: 'JSON',
                beforeSend: function( xhr ){
                    weatherLink.addClass('isDisabled');
                    spinner.addClass('d-flex');
                },
                success: function (response) {

                    if (response) {
                        $('.weather-inner-link').attr('href', response.data);
                        weatherLink.removeClass('isDisabled');
                        spinner.removeClass('d-flex');
                    } else {
                        weatherLink.removeClass('isDisabled');
                        spinner.removeClass('d-flex');
                        console.log('error');
                    }
                }
            });
        }

    });





    $('#weather-month-temperature').on('change', function () {
        window.location.href = $(this).find(":selected").val();
    });

	const lang = $('html').attr('lang');

	//flag for translated page
	if (lang === 'he-IL') {
    setTimeout(function () {
      $('.country-list').remove();
      $('.selected-flag').attr('title', 'Israel: +972');
      $('.iti-flag').addClass('il'); 
		// 			$('.wpcf7-phonetext-country-code').val('+972');
      // 			$('.intl-tel-input input:text').val('+972')

      $('.intl-tel-input input:text').attr('placeholder', 'טלפון');
    }, 200);
  } else if (lang === 'it-IT') {
      $('.country-list').remove();
      $('.selected-flag').attr('title', 'Italy (Italia): +39');
      $('.iti-flag').addClass('it');
      $('.wpcf7-phonetext-country-code').val('+39');
	  
	  if ($('.hero-form-phone').length > 0) {
		  intervalValue = setInterval(function () {
			if ($('.wpcf7-phonetext-country-code').length > 0 && $('.wpcf7-phonetext').val() == '') {
			  $('.wpcf7-phonetext').val('+39');
			  clearInterval(intervalValue);
			}
		  }, 1000);
		}
  } else if (lang === 'ar') {
	intervalValue = setInterval(function () {	
	  
      	var allowedCountryCodes = ["au", "gb", "us", "sa", "ae", "om", "kw", "qa", "il", "dz", "bh", "km", "dj", "eg", "iq", "jo", "lb", "ly", "mr", "ma", "ps", "so", "sd", "sy", "tn", "ye"];
      	$('.country-list li').each(function () {
			var countryCode = $(this).data('country-code');

			if (!allowedCountryCodes.includes(countryCode)) {
			  $(this).remove();
			}
      	});
	  
	}, 1000);
	  
	 if ($('.hero-form-phone').length > 0) {
      intervalValue = setInterval(function () {
        if ($('.wpcf7-phonetext-country-code').length > 0 && $('.wpcf7-phonetext').val() == '') {
          var currentValue = $('.wpcf7-phonetext-country-code').val();
          $('.wpcf7-phonetext').val(currentValue);
          console.log(currentValue);
          clearInterval(intervalValue);
        }
      }, 1000);
    }
	  
	  
  } else if (lang === 'en-US') {
    if ($('.hero-form-phone').length > 0) {
      intervalValue = setInterval(function () {
        if ($('.wpcf7-phonetext-country-code').length > 0 && $('.wpcf7-phonetext').val() == '') {
          var currentValue = $('.wpcf7-phonetext-country-code').val();
          $('.wpcf7-phonetext').val(currentValue);
          console.log(currentValue);
          clearInterval(intervalValue);
        }
      }, 1000);
    }
  }


    $(".career-file").on('change', function() {
        let filename = this.files[0].name;
        $('.file-name').html(filename);
    });


    $('.wpcf7-form').submit(function(event){
        event.preventDefault(); // Prevent the form from submitting normally

        var selectedFlag = $(this).find('.selected-flag');
        var title = selectedFlag.attr('title');

        var matches = title.match(/([^(:]+)[:\(]/);
        if (matches && matches.length > 1) {
            var countryName = matches[1].trim();
        }

        // Set the value of the element with id 'country'
        $(this).find('input[name="country_name"]').val(countryName);
    });


});
